"use strict";
import { Flex, Text } from "ui/src";
export function ModalActionButton({
  label,
  icon,
  onPress,
  disabled
}) {
  return <Flex
    row
    centered
    gap="$gap8"
    width="100%"
    height={48}
    borderWidth={1}
    borderColor="$surface3"
    borderRadius="$rounded12"
    cursor={disabled ? "default" : "pointer"}
    opacity={disabled ? 0.6 : 1}
    hoverStyle={{ backgroundColor: disabled ? "transparent" : "$surface2" }}
    pressStyle={{ backgroundColor: "$surface3" }}
    onPress={disabled ? void 0 : onPress}
  >
      {icon}
      <Text variant="buttonLabel2">{label}</Text>
    </Flex>;
}
